module.exports = __webpack_public_path__ + "img/high.e2ef28ff.png";